import gql from 'graphql-tag'

export default gql`
mutation udpateEvent($record: UpdateByIdEventInput!){
    updateEvent(record:$record){
      recordId
    }
  }
`
